import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const getCometOnboardingStepsQueryKey = () => QueryClientHelper.makeQueryKey('/rest/onboarding/comet');
export const getComputerOnboardingV2QueryKey = ({ subscriptionTier, subSegment, segment, }) => QueryClientHelper.makeQueryKey('/rest/onboarding/computer-v2', {
    subscriptionTier,
    subSegment,
    segment,
});
export const getOrgSuggestionsQueryKey = () => QueryClientHelper.makeQueryKey('/rest/enterprise/v2/user/org-suggestions');
//# sourceMappingURL=onboardingKeys.js.map